const KeyFeatures = () => {
  return (
    <div className='bg-secondary rounded-3 p-5 h-100 fontColor__red'>
      <h4>Key Features</h4>
      <hr />
      
      <div className="clearfix"></div>

      <div className="mt-2">
        <ul className="list-group list-group-flush">
          <li className='list-group-item bg-transparent py-3'>
            BBMP approved 2/3 BHK luxury apts.
          </li>

          <li className='list-group-item bg-transparent py-3'>
            World Class Aminities like Children&apos;s park, Jogging track, Gym, Swimming pool, Party hall, Cafe, Spa, Provision.
          </li>

          <li className='list-group-item bg-transparent py-3'>
            Friendly atmosphere surrounded by greeneries.
          </li>

          <li className='list-group-item bg-transparent py-3'>
            Free from pollution &mbsp; traffic.
          </li>

          <li className='list-group-item bg-transparent py-3'>
            We also undertake Construction, registration, estimation, planning etc. 
          </li>
        </ul>
      </div>
    </div>
  );
}
 
export default KeyFeatures;